'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {"nav-item-icon":"nav-module_nav-item-icon__CDyD6","nav-item":"nav-module_nav-item__yLGR1","nav-item--light":"nav-module_nav-item--light__MubNy","nav-item--dark":"nav-module_nav-item--dark__v-Yk6","nav-link":"nav-module_nav-link__LhiRY","nav-link--active":"nav-module_nav-link--active__DxilJ","nav-link--light":"nav-module_nav-link--light__G1uA0","nav-link--dark":"nav-module_nav-link--dark__FZnc6"};

exports.default = styles;
//# sourceMappingURL=nav.module.scss.js.map
